module.exports = __WEBPACK_EXTERNAL_MODULE_dayjs_plugin_weekYear__;